import { useTranslation } from 'react-i18next';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';

import { MenuButton } from 'components/MenuButton/MenuButton';
import { MenuButtonOption } from 'components/MenuButton/MenuButtonOption';

type ItemActionsMenuProps = {
  onMoveTo: () => void;
  onEditQuantity?: () => void;
};

export const ItemActionsMenu = ({ onMoveTo, onEditQuantity }: ItemActionsMenuProps) => {
  const { t } = useTranslation();

  return (
    <div onPointerDown={(event) => event.stopPropagation()}>
      <MenuButton
        iconOnly
        variant="minimal"
        size="small"
        Icon={EllipsisVerticalIcon}
        text={t('webedi:packing_list.transport_unit.actions.menu')}
        aria-label={t('webedi:packing_list.transport_unit.actions.menu')}
        analyticsId="webedi:packing_list_item_actions"
      >
        <MenuButtonOption onClick={onMoveTo} analyticsId="webedi:packing_list_item_move_to">
          {t('webedi:packing_list.transport_unit.actions.move_to')}
        </MenuButtonOption>
        {onEditQuantity ? (
          <MenuButtonOption onClick={onEditQuantity} analyticsId="webedi:packing_list_item_edit_quantity">
            {t('webedi:packing_list.transport_unit.actions.edit_quantity')}
          </MenuButtonOption>
        ) : null}
      </MenuButton>
    </div>
  );
};
